module.exports = __webpack_public_path__ + "img/SysBR.77e00289.svg";